import React, { lazy, Suspense, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { setCookie, getCookie } from '../common_component/cookie.js';


function AsideNavbar(props) {
	const [access, setaccess] = useState([]);
	const [selected, setSelected] = useState("");
	const [levelOne, setLevelOne] = useState("");
	const [levelTwo, setLevelTwo] = useState("");
	const [LevelThree, setLevelThree] = useState("");
	const [view, setview] = useState("");
	const [MobileView, setMobileView] = useState(false);
	let [Admin_flag, setAdmin_flag] = useState("");

	var page_name = "aside-navbar";

	useEffect(() => {
		//setCookie("lastpage", window.location.href, 1)
		const validateJWT = () => {

			if (getCookie("access_token") != "") {
				var object = {};
				object.token = getCookie("access_token");

				var headers = {
					headers: {
						"Content-Type": "application/json",
						"Accept": "*/*"
					}
				}
				axios.post(`${process.env.REACT_APP_SERVER_URL}/get-user`, object, headers).then((res) => {

					if (res.data.operation == "success") {
						var user_object = {};
						let organization_id = "";

						if (getCookie("organization_id") != "") {
							organization_id = getCookie("organization_id");
							user_object.email = res.data.email;
							var headers = {
								headers: {
									"Content-Type": "application/json",
									"token": getCookie("access_token")
								}
							}
							var object1 = {};
							object1.email = res.data.email;
							object1.page_name = page_name;
							object1.organization_id = organization_id;
							let currentUrl = window.location.href;
							let original_url = currentUrl.split("/");
							//console.log(original_url);
							//console.log(original_url[original_url.length - 1])
							//console.log((/\d/.test(original_url[original_url.length - 1])))
							original_url = original_url[3];
							original_url = original_url.replace(/[^\w -_]/g, '');
							//original_url = (/\d/.test(original_url[original_url.length - 1])) ? original_url[original_url.length - 2] : original_url[original_url.length - 1];
							if (original_url == "") {
								original_url = "dashboard";
							}
							let index1 = 0;
							if (navigator.userAgent.match(/Android/i)
							|| navigator.userAgent.match(/webOS/i)
							|| navigator.userAgent.match(/iPhone/i)
							|| navigator.userAgent.match(/iPad/i)
							|| navigator.userAgent.match(/iPod/i)
							|| navigator.userAgent.match(/BlackBerry/i)
							|| navigator.userAgent.match(/Windows Phone/i)) 
							{
								setMobileView(true);
								console.log("mobile:true");
							}
							else
							{
								setMobileView(false)
								console.log("mobile:false");
							}
							const isMobile = window.matchMedia('only screen and (max-width: 768px)').matches;
							console.log("id: "+isMobile)
							axios.post(`${process.env.REACT_APP_SERVER_URL}/user-access-info`, object1, headers).then((res1) => {
								if (res1.data.operation == "success") {
									setaccess(res1.data.data.access);
									//console.log(res1.data.data.access.filter(option => option.key == 'Admin View').length)
									setAdmin_flag(res1.data.data.access.filter(option => option.key == 'Admin View').length);

									for (let i = 0; i < res1.data.data.access.length; i++) {
										let component = res1.data.data.access[i].inside_components;
										for (let j = 0; j < component.length; j++) {
											if (component[j].hasOwnProperty(original_url)) {
												index1 = i;
												//console.log(res1.data.data.access[index1].key)
												setview(res1.data.data.access[index1].key);
											}
											else if (component[j].hasOwnProperty("key")) {
												let sub_inside_components = component[j].inside_components
												for (let k = 0; k < sub_inside_components.length; k++) {
													if (sub_inside_components[k].hasOwnProperty(original_url)) {
														index1 = i;
														//console.log(res1.data.data.access[index1].key)
														setview(res1.data.data.access[index1].key);
													}
													else if (sub_inside_components[k].hasOwnProperty("key")) {
														//console.log(sub_inside_components[k]);
														for (let l = 0; l < sub_inside_components[k].inside_components.length; l++) {
															if (sub_inside_components[k].inside_components[l].hasOwnProperty(original_url)) {
																index1 = i;
																//console.log(res1.data.data.access[index1].key)
																setview(res1.data.data.access[index1].key);
															}
														}
													}
												}
											}
										}
									}
								}
								else {
									setaccess({});
								}

							})
						}
						else {
							var object = {};
							object.page_name = page_name;
							var headers = {
								headers: {
									"Content-Type": "application/json",
									"token": getCookie("access_token"),
									"Accept": "*/*"
								}
							}

							axios.post(`${process.env.REACT_APP_SERVER_URL}/show-default-organization`, object, headers).then((res) => {

								if (res.data.length > 0) {
									//console.log(res.data[0].organization_id)
									organization_id = res.data[0].organization_id;
									user_object.email = res.data.email;
									var headers = {
										headers: {
											"Content-Type": "application/json",
											"token": getCookie("access_token")
										}
									}
									var object1 = {};
									object1.email = res.data.email;
									object1.page_name = page_name;
									object1.organization_id = organization_id;
									axios.post(`${process.env.REACT_APP_SERVER_URL}/user-access-info`, object1, headers).then((res1) => {
										setaccess(res1.data.data.access)
									})
								}

							})
						}
					}

				})

			}
		}
		validateJWT();
	}, [])

	let optionMap = {
		"/account-overview": [],
		"/add-user": [],
		"/show-user": ["/update-user"],

		"/roles": ["/update-roles"],
		"/profiles": ["/update-profile"],

		"/dealer-order-list": ["/edit-dealer-order", "/view-dealer-order"],
		"/list-dealer": ["/update-dealer","/dealer-address-details"],

		"/list-manufacturer": ["/update-manufacturer"],
		"/list-vendor": ["/update-vendor"],
		"/list-creditor": ["/update-creditor"],
		"/customer-list": ["/edit-customer-details","/customer-address-details"],

		"/add-category": [],
		"/category-list": [],
		"/subcategory-list": [],

		"/dealer-collection-entry": [],
		"/dealer-master-voucher-list": ["/dealer-master-voucher-summary"],
		"/dealer-collection-list": ["/edit-dealer-collection-entry","/edit-dealer-pdc-collection-entry"],

		"/add-subcategory": [],
		"/subcategory-list": [],

		"/creditor-purchase-order-list": ["/edit-creditor-purchase-order","/view-creditor-purchase-order","/creditor-purchase-order-approval-email"],
		"/creditor-purchase-order-approver-list": ["/creditor-purchase-order-approval-preview"],

		"/add-item": [],
		"/item-list": ["/item-images", "/edit-item", "/item-price-information", "/item-stock-information"],

		"none": ["/", "/dashboard", "/admin-dashboard", "/login"]
	}
	let not_show = ["edit-dealer-sale-entry","edit-isd-sale-entry","item-images","dealer-master-voucher-summary","edit-dealer-collection-entry","edit-dealer-pdc-collection-entry","update-roles", "update-profile", "edit-item", "edit-dealer-order", "view-dealer-order", "dealer-order-approval-preview", "process-dealer-order-invoice", "edit-dealer-invoice", "view-dealer-invoice", "dealer-invoice-approval-preview", "dealer-warehouse-processing", "add-account", "edit-pjp-plan", "dso-check-out", "view-visit-log", "update-vendor", "update-dealer", "dealer-address-details", "update-manufacturer", "update-creditor", "edit-customer-details", "view-customer-details", "customer-address-details", "item-price-information", "item-stock-information","edit-item-stock-information","creditor-address-details", "balance-details"]

	useEffect(() => {
		let id = setInterval(() => {
			let currentUrl = window.location.href
			let t = currentUrl.split("/")

			t = (/\d/.test(t[t.length - 1])) ? t[t.length - 2] : t[t.length - 1]
			t = t.replace(/[^\w -]/g, '');
			//console.log(t);
			let targetOption = undefined;
			Object.keys(optionMap).forEach((elem) => {
				if (optionMap[elem].includes("/" + t)) {
					targetOption = elem
				}
			})
			//console.log(targetOption)
			//console.log(t)
			if (targetOption == undefined) {
				setSelected(t)
			}
			else {
				if (targetOption != "none") {
					setSelected(targetOption.replace("/", ""))
				}
			}

		}, 500)
		return () => {
			clearInterval(id)
		}
	}, [])

	//Function for custom link as per item name in the json
	const customLink = (option) => {
		return `/${option}`
	}
	//Function to format Menu Header and submenu items 
	const formatString = (str) => {

		if((str.includes("dealer")) && ( (str.includes("order")) || (str.includes("invoice")) || (str.includes("warehouse")) || (str.includes("delivery")) || (str.includes("bill")) ) ){
			let allWords = str.replace(/_/g, ' ').replace(/-/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
			return allWords
		}
		else if (str.includes("pjp")) {
			let allWords = str.replace(/-/g, ' ').replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
			allWords.split(" ").splice(-2).join(" ")
			allWords = allWords.replace("Pjp", "PJP")
			return allWords
		}
		else if (str.includes("pdc")) {
			let allWords = "PDC Entry"
			return allWords
		}
		else if (str.includes("_")) {
			//Removing "_" and formatting first letter of each word to Capital
			return str.split("_")[0].replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
		}
		else if (str.includes("-")) {
			//Removing "-" and formatting first letter of each word to Capital and showing last 2 word of the string
			let allWords = str.replace(/-/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
			return allWords.split(" ").splice(-2).join(" ")
		}
		else {
			let allWords = str.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
			return allWords.split(" ").splice(-2).join(" ")
		}
		
	}
	//Function to render custom icon as per Menu Title in the json
	const customIcon = (menuName) => {
		//console.log(menuName)
		if (menuName === "admin-dashboard" || menuName === "dashboard") {
			return (
				<span className="svg-icon svg-icon-2">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6.5 11C8.98528 11 11 8.98528 11 6.5C11 4.01472 8.98528 2 6.5 2C4.01472 2 2 4.01472 2 6.5C2 8.98528 4.01472 11 6.5 11Z" fill="currentColor" />
						<path opacity="0.3" d="M13 6.5C13 4 15 2 17.5 2C20 2 22 4 22 6.5C22 9 20 11 17.5 11C15 11 13 9 13 6.5ZM6.5 22C9 22 11 20 11 17.5C11 15 9 13 6.5 13C4 13 2 15 2 17.5C2 20 4 22 6.5 22ZM17.5 22C20 22 22 20 22 17.5C22 15 20 13 17.5 13C15 13 13 15 13 17.5C13 20 15 22 17.5 22Z" fill="currentColor" />
					</svg>
				</span>
			)
		}
		else if (menuName === "organization") {
			return (
				<span className="svg-icon svg-icon-2">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z" fill="currentColor"></path>
						<path opacity="0.3" d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z" fill="currentColor"></path>
					</svg>
				</span>
			)
		}
		else if (menuName === "collection") {
			return (
				<span className="svg-icon svg-icon-2">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path opacity="0.3" d="M12.5 22C11.9 22 11.5 21.6 11.5 21V3C11.5 2.4 11.9 2 12.5 2C13.1 2 13.5 2.4 13.5 3V21C13.5 21.6 13.1 22 12.5 22Z" fill="currentColor"/>
						<path d="M17.8 14.7C17.8 15.5 17.6 16.3 17.2 16.9C16.8 17.6 16.2 18.1 15.3 18.4C14.5 18.8 13.5 19 12.4 19C11.1 19 10 18.7 9.10001 18.2C8.50001 17.8 8.00001 17.4 7.60001 16.7C7.20001 16.1 7 15.5 7 14.9C7 14.6 7.09999 14.3 7.29999 14C7.49999 13.8 7.80001 13.6 8.20001 13.6C8.50001 13.6 8.69999 13.7 8.89999 13.9C9.09999 14.1 9.29999 14.4 9.39999 14.7C9.59999 15.1 9.8 15.5 10 15.8C10.2 16.1 10.5 16.3 10.8 16.5C11.2 16.7 11.6 16.8 12.2 16.8C13 16.8 13.7 16.6 14.2 16.2C14.7 15.8 15 15.3 15 14.8C15 14.4 14.9 14 14.6 13.7C14.3 13.4 14 13.2 13.5 13.1C13.1 13 12.5 12.8 11.8 12.6C10.8 12.4 9.99999 12.1 9.39999 11.8C8.69999 11.5 8.19999 11.1 7.79999 10.6C7.39999 10.1 7.20001 9.39998 7.20001 8.59998C7.20001 7.89998 7.39999 7.19998 7.79999 6.59998C8.19999 5.99998 8.80001 5.60005 9.60001 5.30005C10.4 5.00005 11.3 4.80005 12.3 4.80005C13.1 4.80005 13.8 4.89998 14.5 5.09998C15.1 5.29998 15.6 5.60002 16 5.90002C16.4 6.20002 16.7 6.6 16.9 7C17.1 7.4 17.2 7.69998 17.2 8.09998C17.2 8.39998 17.1 8.7 16.9 9C16.7 9.3 16.4 9.40002 16 9.40002C15.7 9.40002 15.4 9.29995 15.3 9.19995C15.2 9.09995 15 8.80002 14.8 8.40002C14.6 7.90002 14.3 7.49995 13.9 7.19995C13.5 6.89995 13 6.80005 12.2 6.80005C11.5 6.80005 10.9 7.00005 10.5 7.30005C10.1 7.60005 9.79999 8.00002 9.79999 8.40002C9.79999 8.70002 9.9 8.89998 10 9.09998C10.1 9.29998 10.4 9.49998 10.6 9.59998C10.8 9.69998 11.1 9.90002 11.4 9.90002C11.7 10 12.1 10.1 12.7 10.3C13.5 10.5 14.2 10.7 14.8 10.9C15.4 11.1 15.9 11.4 16.4 11.7C16.8 12 17.2 12.4 17.4 12.9C17.6 13.4 17.8 14 17.8 14.7Z" fill="currentColor"/>
					</svg>
				</span>
			)
		}
		else if (menuName === "item") {
			return (
				<span className="svg-icon svg-icon-2">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M21 10H13V11C13 11.6 12.6 12 12 12C11.4 12 11 11.6 11 11V10H3C2.4 10 2 10.4 2 11V13H22V11C22 10.4 21.6 10 21 10Z" fill="currentColor"></path>
						<path opacity="0.3" d="M12 12C11.4 12 11 11.6 11 11V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V11C13 11.6 12.6 12 12 12Z" fill="currentColor"></path>
						<path opacity="0.3" d="M18.1 21H5.9C5.4 21 4.9 20.6 4.8 20.1L3 13H21L19.2 20.1C19.1 20.6 18.6 21 18.1 21ZM13 18V15C13 14.4 12.6 14 12 14C11.4 14 11 14.4 11 15V18C11 18.6 11.4 19 12 19C12.6 19 13 18.6 13 18ZM17 18V15C17 14.4 16.6 14 16 14C15.4 14 15 14.4 15 15V18C15 18.6 15.4 19 16 19C16.6 19 17 18.6 17 18ZM9 18V15C9 14.4 8.6 14 8 14C7.4 14 7 14.4 7 15V18C7 18.6 7.4 19 8 19C8.6 19 9 18.6 9 18Z" fill="currentColor"></path>
					</svg>
				</span>
			)
		}
		else if (menuName === "settings") {
			return (
				<span className="svg-icon svg-icon-2">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor"/>
						<path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor"/>
					</svg>
				</span>
			)
		}
		else if (menuName === "dealer_invoice" || menuName === "dealer_order" || menuName === "PO_creditor") {
			return (
				<span className="svg-icon svg-icon-2">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M22 7H2V11H22V7Z" fill="currentColor"></path>
						<path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19ZM14 14C14 13.4 13.6 13 13 13H5C4.4 13 4 13.4 4 14C4 14.6 4.4 15 5 15H13C13.6 15 14 14.6 14 14ZM16 15.5C16 16.3 16.7 17 17.5 17H18.5C19.3 17 20 16.3 20 15.5C20 14.7 19.3 14 18.5 14H17.5C16.7 14 16 14.7 16 15.5Z" fill="currentColor"></path>
					</svg>
				</span>
			)
		}
		else if (menuName === "pjp_plan") {
			return (
				<span className="svg-icon svg-icon-2">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
						<path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
						<path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
					</svg>
				</span>
			)
		}
		else if (menuName === "account-overview") {
			return (
				<span className="svg-icon svg-icon-2">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor"></path>
						<rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor"></rect>
					</svg>
				</span>
			)
		}
		else if (menuName === "user") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor"></path>
					<rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor"></rect>
				</svg>
			)
		}
		else if (menuName === "project") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M18 21.6C16.6 20.4 9.1 20.3 6.3 21.2C5.7 21.4 5.1 21.2 4.7 20.8L2 18C4.2 15.8 10.8 15.1 15.8 15.8C16.2 18.3 17 20.5 18 21.6ZM18.8 2.8C18.4 2.4 17.8 2.20001 17.2 2.40001C14.4 3.30001 6.9 3.2 5.5 2C6.8 3.3 7.4 5.5 7.7 7.7C9 7.9 10.3 8 11.7 8C15.8 8 19.8 7.2 21.5 5.5L18.8 2.8Z" fill="currentColor"></path>
					<path opacity="0.3" d="M21.2 17.3C21.4 17.9 21.2 18.5 20.8 18.9L18 21.6C15.8 19.4 15.1 12.8 15.8 7.8C18.3 7.4 20.4 6.70001 21.5 5.60001C20.4 7.00001 20.2 14.5 21.2 17.3ZM8 11.7C8 9 7.7 4.2 5.5 2L2.8 4.8C2.4 5.2 2.2 5.80001 2.4 6.40001C2.7 7.40001 3.00001 9.2 3.10001 11.7C3.10001 15.5 2.40001 17.6 2.10001 18C3.20001 16.9 5.3 16.2 7.8 15.8C8 14.2 8 12.7 8 11.7Z" fill="currentColor"></path>
				</svg>
			)
		}
		else if (menuName === "category-list") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path opacity="0.3" d="M7 20.5L2 17.6V11.8L7 8.90002L12 11.8V17.6L7 20.5ZM21 20.8V18.5L19 17.3L17 18.5V20.8L19 22L21 20.8Z" fill="currentColor"></path>
					<path d="M22 14.1V6L15 2L8 6V14.1L15 18.2L22 14.1Z" fill="currentColor"></path>
				</svg>
			)
		}
		else if (menuName === "policy") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path opacity="0.3" d="M14 3V20H2V3C2 2.4 2.4 2 3 2H13C13.6 2 14 2.4 14 3ZM11 13V11C11 9.7 10.2 8.59995 9 8.19995V7C9 6.4 8.6 6 8 6C7.4 6 7 6.4 7 7V8.19995C5.8 8.59995 5 9.7 5 11V13C5 13.6 4.6 14 4 14V15C4 15.6 4.4 16 5 16H11C11.6 16 12 15.6 12 15V14C11.4 14 11 13.6 11 13Z" fill="currentColor"></path>
					<path d="M2 20H14V21C14 21.6 13.6 22 13 22H3C2.4 22 2 21.6 2 21V20ZM9 3V2H7V3C7 3.6 7.4 4 8 4C8.6 4 9 3.6 9 3ZM6.5 16C6.5 16.8 7.2 17.5 8 17.5C8.8 17.5 9.5 16.8 9.5 16H6.5ZM21.7 12C21.7 11.4 21.3 11 20.7 11H17.6C17 11 16.6 11.4 16.6 12C16.6 12.6 17 13 17.6 13H20.7C21.2 13 21.7 12.6 21.7 12ZM17 8C16.6 8 16.2 7.80002 16.1 7.40002C15.9 6.90002 16.1 6.29998 16.6 6.09998L19.1 5C19.6 4.8 20.2 5 20.4 5.5C20.6 6 20.4 6.60005 19.9 6.80005L17.4 7.90002C17.3 8.00002 17.1 8 17 8ZM19.5 19.1C19.4 19.1 19.2 19.1 19.1 19L16.6 17.9C16.1 17.7 15.9 17.1 16.1 16.6C16.3 16.1 16.9 15.9 17.4 16.1L19.9 17.2C20.4 17.4 20.6 18 20.4 18.5C20.2 18.9 19.9 19.1 19.5 19.1Z" fill="currentColor"></path>
				</svg>
			)
		}
		else if (menuName === "role") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z" fill="currentColor"></path>
					<path opacity="0.3" d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z" fill="currentColor"></path>
				</svg>
			)
		}
		else if (menuName === "profile") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z" fill="currentColor"></path>
					<path opacity="0.3" d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z" fill="currentColor"></path>
				</svg>
			)
		}
		else if (menuName === "merchant") {
			return (
				<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path opacity="0.3" d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z" fill="currentColor"></path>
					<path d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z" fill="currentColor"></path>
				</svg>
			)
		}
		else if (menuName === "show-organizations") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z" fill="currentColor"></path>
					<path opacity="0.3" d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z" fill="currentColor"></path>
				</svg>
			)
		}
		else if (menuName === "payments" || menuName === "currency") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path opacity="0.3" d="M20.859 12.596L17.736 13.596L10.388 20.944C10.2915 21.0406 10.1769 21.1172 10.0508 21.1695C9.9247 21.2218 9.78953 21.2486 9.65302 21.2486C9.5165 21.2486 9.3813 21.2218 9.25519 21.1695C9.12907 21.1172 9.01449 21.0406 8.918 20.944L2.29999 14.3229C2.10543 14.1278 1.99619 13.8635 1.99619 13.588C1.99619 13.3124 2.10543 13.0481 2.29999 12.853L11.853 3.29999C11.9495 3.20341 12.0641 3.12679 12.1902 3.07452C12.3163 3.02225 12.4515 2.9953 12.588 2.9953C12.7245 2.9953 12.8597 3.02225 12.9858 3.07452C13.1119 3.12679 13.2265 3.20341 13.323 3.29999L21.199 11.176C21.3036 11.2791 21.3797 11.4075 21.4201 11.5486C21.4605 11.6898 21.4637 11.8391 21.4295 11.9819C21.3953 12.1247 21.3249 12.2562 21.2249 12.3638C21.125 12.4714 20.9989 12.5514 20.859 12.596Z" fill="currentColor"></path>
					<path d="M14.8 10.184C14.7447 10.1843 14.6895 10.1796 14.635 10.1699L5.816 8.69997C5.55436 8.65634 5.32077 8.51055 5.16661 8.29469C5.01246 8.07884 4.95035 7.8106 4.99397 7.54897C5.0376 7.28733 5.18339 7.05371 5.39925 6.89955C5.6151 6.7454 5.88334 6.68332 6.14498 6.72694L14.963 8.19692C15.2112 8.23733 15.435 8.36982 15.59 8.56789C15.7449 8.76596 15.8195 9.01502 15.7989 9.26564C15.7784 9.51626 15.6642 9.75001 15.479 9.92018C15.2939 10.0904 15.0514 10.1846 14.8 10.184ZM17 18.6229C17 19.0281 17.0985 19.4272 17.287 19.7859C17.4755 20.1446 17.7484 20.4521 18.0821 20.6819C18.4158 20.9117 18.8004 21.0571 19.2027 21.1052C19.605 21.1534 20.0131 21.103 20.3916 20.9585C20.7702 20.814 21.1079 20.5797 21.3758 20.2757C21.6437 19.9716 21.8336 19.607 21.9293 19.2133C22.025 18.8195 22.0235 18.4085 21.925 18.0154C21.8266 17.6223 21.634 17.259 21.364 16.9569L19.843 15.257C19.7999 15.2085 19.7471 15.1697 19.688 15.1432C19.6289 15.1167 19.5648 15.1029 19.5 15.1029C19.4352 15.1029 19.3711 15.1167 19.312 15.1432C19.2529 15.1697 19.2001 15.2085 19.157 15.257L17.636 16.9569C17.2254 17.4146 16.9988 18.0081 17 18.6229ZM10.388 20.9409L17.736 13.5929H1.99999C1.99921 13.7291 2.02532 13.8643 2.0768 13.9904C2.12828 14.1165 2.2041 14.2311 2.29997 14.3279L8.91399 20.9409C9.01055 21.0381 9.12539 21.1152 9.25188 21.1679C9.37836 21.2205 9.51399 21.2476 9.65099 21.2476C9.78798 21.2476 9.92361 21.2205 10.0501 21.1679C10.1766 21.1152 10.2914 21.0381 10.388 20.9409Z" fill="currentColor"></path>
				</svg>
			)
		}
		else if (menuName === "customer") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M11.7 8L7.49998 15.3L4.59999 20.3C3.49999 18.4 3.1 17.7 2.3 16.3C1.9 15.7 1.9 14.9 2.3 14.3L8.8 3L11.7 8Z" fill="currentColor"></path>
					<path opacity="0.3" d="M11.7 8L8.79999 3H13.4C14.1 3 14.8 3.4 15.2 4L20.6 13.3H14.8L11.7 8ZM7.49997 15.2L4.59998 20.2H17.6C18.3 20.2 19 19.8 19.4 19.2C20.2 17.7 20.6 17 21.7 15.2H7.49997Z" fill="currentColor"></path>
				</svg>
			)
		}
		else if (menuName === "approvals") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M13 5.91517C15.8 6.41517 18 8.81519 18 11.8152C18 12.5152 17.9 13.2152 17.6 13.9152L20.1 15.3152C20.6 15.6152 21.4 15.4152 21.6 14.8152C21.9 13.9152 22.1 12.9152 22.1 11.8152C22.1 7.01519 18.8 3.11521 14.3 2.01521C13.7 1.91521 13.1 2.31521 13.1 3.01521V5.91517H13Z" fill="currentColor"></path>
					<path opacity="0.3" d="M19.1 17.0152C19.7 17.3152 19.8 18.1152 19.3 18.5152C17.5 20.5152 14.9 21.7152 12 21.7152C9.1 21.7152 6.50001 20.5152 4.70001 18.5152C4.30001 18.0152 4.39999 17.3152 4.89999 17.0152L7.39999 15.6152C8.49999 16.9152 10.2 17.8152 12 17.8152C13.8 17.8152 15.5 17.0152 16.6 15.6152L19.1 17.0152ZM6.39999 13.9151C6.19999 13.2151 6 12.5152 6 11.8152C6 8.81517 8.2 6.41515 11 5.91515V3.01519C11 2.41519 10.4 1.91519 9.79999 2.01519C5.29999 3.01519 2 7.01517 2 11.8152C2 12.8152 2.2 13.8152 2.5 14.8152C2.7 15.4152 3.4 15.7152 4 15.3152L6.39999 13.9151Z" fill="currentColor"></path>
				</svg>
			)
		}
		else if (menuName === "tax") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M22 7H2V11H22V7Z" fill="currentColor"></path>
					<path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19ZM14 14C14 13.4 13.6 13 13 13H5C4.4 13 4 13.4 4 14C4 14.6 4.4 15 5 15H13C13.6 15 14 14.6 14 14ZM16 15.5C16 16.3 16.7 17 17.5 17H18.5C19.3 17 20 16.3 20 15.5C20 14.7 19.3 14 18.5 14H17.5C16.7 14 16 14.7 16 15.5Z" fill="currentColor"></path>
				</svg>
			)
		}
		else if (menuName === "settings") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z" fill="currentColor" />
					<path opacity="0.3" d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z" fill="currentColor" />
				</svg>
			)
		}
		else if (menuName === "vendor") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M21 10H13V11C13 11.6 12.6 12 12 12C11.4 12 11 11.6 11 11V10H3C2.4 10 2 10.4 2 11V13H22V11C22 10.4 21.6 10 21 10Z" fill="currentColor" />
					<path opacity="0.3" d="M12 12C11.4 12 11 11.6 11 11V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V11C13 11.6 12.6 12 12 12Z" fill="currentColor" />
					<path opacity="0.3" d="M18.1 21H5.9C5.4 21 4.9 20.6 4.8 20.1L3 13H21L19.2 20.1C19.1 20.6 18.6 21 18.1 21ZM13 18V15C13 14.4 12.6 14 12 14C11.4 14 11 14.4 11 15V18C11 18.6 11.4 19 12 19C12.6 19 13 18.6 13 18ZM17 18V15C17 14.4 16.6 14 16 14C15.4 14 15 14.4 15 15V18C15 18.6 15.4 19 16 19C16.6 19 17 18.6 17 18ZM9 18V15C9 14.4 8.6 14 8 14C7.4 14 7 14.4 7 15V18C7 18.6 7.4 19 8 19C8.6 19 9 18.6 9 18Z" fill="currentColor" />
				</svg>
			)
		}
		else if (menuName === "dealer") {
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path opacity="0.3" d="M7 20.5L2 17.6V11.8L7 8.90002L12 11.8V17.6L7 20.5ZM21 20.8V18.5L19 17.3L17 18.5V20.8L19 22L21 20.8Z" fill="currentColor" />
					<path d="M22 14.1V6L15 2L8 6V14.1L15 18.2L22 14.1Z" fill="currentColor" />
				</svg>
			)
		}
		else {
			return (
				<span className="svg-icon svg-icon-2">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M20 7H3C2.4 7 2 6.6 2 6V3C2 2.4 2.4 2 3 2H20C20.6 2 21 2.4 21 3V6C21 6.6 20.6 7 20 7ZM7 9H3C2.4 9 2 9.4 2 10V20C2 20.6 2.4 21 3 21H7C7.6 21 8 20.6 8 20V10C8 9.4 7.6 9 7 9Z" fill="currentColor"></path>
						<path opacity="0.3" d="M20 21H11C10.4 21 10 20.6 10 20V10C10 9.4 10.4 9 11 9H20C20.6 9 21 9.4 21 10V20C21 20.6 20.6 21 20 21Z" fill="currentColor"></path>
					</svg>
				</span>
			)
		}
	}


	const handleLvOne = (title) => {
		// console.log(title)
		handleLvTwo("")
		if (title === levelOne) {
			setLevelOne("")
		}
		else {
			setLevelOne(title)
		}
	}
	const handleLvTwo = (title) => {
		//console.log(title,levelTwo)
		handleLvThree("");
		if (title === levelTwo) {
			setLevelTwo("")
		}
		else {
			setLevelTwo(title)
		}
	}

	const handleLvThree = (title) => {
		//console.log(title,LevelThree)
		if (title === LevelThree) {
			setLevelThree("");
		}
		else {
			setLevelThree(title)
		}
	}

	useEffect(() => {
		if (access.length > 0) {
			access.map((obj) => {
				if (obj.hasOwnProperty("key")) {
					let tempArr1 = []
					obj.inside_components.forEach(x => {
						if (Object.keys(x)[0] === "key") {
							x.inside_components.forEach(y => {
								if (Object.keys(y)[0] === "key") {
									y.inside_components.forEach(z => tempArr1.push(Object.keys(z)[0]));
								}
								else {
									tempArr1.push(Object.keys(y)[0]);
								}
							})
						}
						else {
							tempArr1.push(Object.keys(x)[0])
						}
					})

					if (tempArr1.includes(selected)) {
						handleLvOne(obj.key)
					}
					//console.log(tempArr1)
				}
			})

			let tempArr2 = []
			access.forEach((obj) => {
				obj.inside_components.forEach(x => {
					if (Object.keys(x)[0] === "key") {
						tempArr2.push(x)
					}
				})
			})
			tempArr2.forEach((obj) => {
				obj.inside_components.forEach(y => {
					if (Object.keys(y)[0] === "key") {
						let arr = [];
						y.inside_components.forEach(z => arr.push(Object.keys(z)[0]));
						if (arr.includes(selected)) {
							handleLvTwo(obj.key)
						}
					}
					else {
						let a = obj.inside_components.map(y => Object.keys(y)[0])
						if (a.includes(selected)) {
							handleLvTwo(obj.key)
						}
					}
				})
			})

			let tempArr3 = []
			access.forEach((obj) => {
				obj.inside_components.forEach(x => {
					if (Object.keys(x)[0] === "key") {
						//console.log(x);
						x.inside_components.forEach(y => {
							if (Object.keys(y)[0] === "key") {
								//console.log(y);
								tempArr3.push(y);
							}
						})
					}
				})
			})
			//console.log(tempArr3)
			tempArr3.forEach((obj) => {
				let a = obj.inside_components.map(y => Object.keys(y)[0]);
				//console.log(obj.inside_components)
				//console.log(a)
				if (a.includes(selected)) {
					//console.log("x")
					handleLvThree(obj.key)
				}
			})
		}

	}, [access])

	const nav_select = (val) => {
		if (val == true) {
			window.location.href = "/admin-dashboard";
		}
		else {
			window.location.href = "/dashboard";
		}
	}

	return (
		<>
			<div className={`app-sidebar flex-column ${MobileView?("drawer drawer-start "+(props.asideRef?"drawer-on":"")):""}`} tabIndex="-1"  ref={props.carRef} style={{transition: "transform .3s ease-in-out",overflow:"scroll"}} onFocus={() => {/*console.log("ac");*/}} onBlur={() => {props.asideRefFunc(false);}}>
				<div className="app-sidebar-logo px-6">
					<Link to="/">
						<img alt="Logo" src="https://cdnstatic.adoerp.com/static/ado-erp-logo.png" className="h-25px app-sidebar-logo-default" />
						<img alt="Logo" src="https://cdnstatic.adoerp.com/static/ado-erp-logo.png" className="h-20px app-sidebar-logo-minimize" />
					</Link>

					{/* <div onClick={() => {aside_close();}} className="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate">

						<span className="svg-icon svg-icon-2 rotate-180">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path opacity="0.5" d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z" fill="currentColor" />
								<path d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z" fill="currentColor" />
							</svg>
						</span>
					</div> */}
				</div>

				<div className="app-sidebar-menu overflow-hidden flex-column-fluid">
					<div className="app-sidebar-wrapper hover-scroll-overlay-y my-5" /*style={{height: MobileView?"478px;":"478px"}}*/>
						<div className="menu menu-column menu-rounded menu-sub-indention px-3">
							{Admin_flag == 1 &&
								<div className="d-flex align-items-stretch">
									<div className="topbar-item px-3 px-lg-5">
										<label className="form-check form-switch form-check-custom form-check-solid">
											{view == "Admin View" ?
												<input className="form-check-input" type="checkbox" onClick={(e) => { nav_select(e.target.checked); }} checked={true} readOnly />
												:
												<input className="form-check-input" type="checkbox" onClick={(e) => { nav_select(e.target.checked); }} checked={false} readOnly />
											}
											<span className="form-check-label fw-semibold text-muted">{view}</span>
										</label>
									</div>
								</div>
							}
							{
								access.length > 0 && access.map((obj, index) => {
									let variable = false

									let tempArr = []
									obj.inside_components.forEach(x => {
										if (Object.keys(x)[0] === "key") {
											x.inside_components.forEach(y => tempArr.push(Object.keys(y)[0]))
										}
										else {
											tempArr.push(Object.keys(x)[0])
										}
									})

									if (tempArr.includes(selected)) {
										variable = true
									}
									return (
										<React.Fragment key={index}>
											{
												(obj.hasOwnProperty("key") && obj.visibility == 1 && obj.key == view) &&
												<>
													<div className="menu-item pt-5">
														<div className="menu-content">
															<span className="menu-heading fw-bold text-uppercase fs-7">{formatString(obj.key)}</span>
														</div>
													</div>
													{
														obj.inside_components.length > 0 && obj.inside_components.map((obj1, index1) => {
															return (
																<React.Fragment key={index1}>
																	{
																		(obj1.hasOwnProperty("key") && obj1.visibility == 1) ?
																		<div className={`menu-item menu-accordion  ${(levelTwo === obj1.key) ? "hover show" : ""}`}>
																			<span className="menu-link" onClick={() => { handleLvTwo(obj1.key) }}>
																				<span className="menu-icon">{customIcon(obj1.key)}</span>
																				<span className="menu-title">{formatString(obj1.key)}</span>
																				<span className="menu-arrow"></span>
																			</span>
																			<div className="menu-sub menu-sub-accordion menu-active-bg">

																				{
																					obj1.inside_components.length > 0 && obj1.inside_components.map((obj2, index2) => {
																						return (
																							<React.Fragment key={index2}>
																								{
																									(obj2.hasOwnProperty("key") && obj2.visibility == 1) ?
																									<div className={`menu-item menu-accordion  ${(LevelThree === obj2.key) ? "hover show" : ""}`}>
																										<span className="menu-link" onClick={() => { handleLvThree(obj2.key) }}>
																											<span className="menu-bullet"><span className="bullet bullet-dot"></span></span>
																											<span className="menu-title">{formatString(obj2.key)}</span>
																											<span className="menu-arrow"></span>
																										</span>
																										<div className={`menu-sub menu-sub-accordion  ${(LevelThree === obj2.key) ? "show" : ""}`}>
																											{
																												obj2.inside_components.length > 0 && obj2.inside_components.map((obj3, index3) => {
																													return (
																														<React.Fragment key={index3}>
																															{
																																(Object.values(obj3)[0] == 1) && (!not_show.includes(Object.keys(obj3)[0])) &&
																																<div className="menu-item">
																																	<Link className={`menu-link ${(selected === Object.keys(obj3)[0]) ? "active" : ""}`} to={customLink(Object.keys(obj3)[0])} onClick={() => {setSelected(Object.keys(obj3)[0]) }}>
																																		<span className="menu-bullet">
																																			<span className="bullet bullet-dot"></span>
																																		</span>
																																		<span className="menu-title">{formatString(Object.keys(obj3)[0])}</span>
																																	</Link>
																																</div>
																															}
																														</React.Fragment>
																													)
																												})
																											}
																										</div>
																									</div>
																									:
																									<>
																										{
																											(Object.values(obj2)[0] == 1) && (!not_show.includes(Object.keys(obj2)[0])) &&
																											<div className="menu-item">
																												<Link className={`menu-link ${(selected === Object.keys(obj2)[0]) ? "active" : ""}`} to={customLink(Object.keys(obj2)[0])} onClick={() => {setSelected(Object.keys(obj2)[0]) }}>
																													<span className="menu-bullet">
																														<span className="bullet bullet-dot"></span>
																													</span>
																													<span className="menu-title">{formatString(Object.keys(obj2)[0])}</span>
																												</Link>
																											</div>
																										}
																									</>
																								}
																							</React.Fragment>
																						)
																					})
																				}
																			</div>
																		</div>
																		:
																		((Object.values(obj1)[0] == 1) && (!not_show.includes(Object.keys(obj1)[0]))) &&
																		<div className="menu-item">
																			<Link className={`menu-link ${(selected === Object.keys(obj1)[0]) ? "active" : ""}`} to={customLink(Object.keys(obj1)[0])} onClick={() => {setSelected(Object.keys(obj1)[0]) }}>
																				<span className="menu-icon">
																					{customIcon(Object.keys(obj1)[0])}
																				</span>
																				<span className="menu-title">{((Object.keys(obj1)[0] === "show-user") ? "Team" : ((Object.keys(obj1)[0] === "combo-item-list") ? "Combo Item List" : ((Object.keys(obj1)[0] === "support") ? "Send us Query" : ((Object.keys(obj1)[0] === "support-query-list") ? "Tickets" : formatString(Object.keys(obj1)[0])))))}</span>
																			</Link>
																		</div>
																	}
																</React.Fragment>
															)
														})
													}
												</>
											}
										</React.Fragment>
									)
								})
							}
						</div>
					</div>
				</div>

				<div className="app-sidebar-footer flex-column-auto pt-2 pb-6 px-6">
					<a onClick={(event) => { setCookie("access_token", "", -1, true); setCookie("organization_id", "", -1, true); window.location.href = "/login"; }} className="btn btn-custom btn-primary w-100" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-delay-show="8000" title="Check out the complete documentation with over 100 components">
						<span className="btn-label">Sign Out</span>
						<span className="svg-icon btn-icon svg-icon-2">
							<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
									<rect x="0" y="0" width="24" height="24" />
									<path d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z" fill="#000000" opacity="0.3" />
									<path d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z" fill="#000000" />
									<rect fill="#000000" opacity="0.3" x="7" y="10" width="5" height="2" rx="1" />
									<rect fill="#000000" opacity="0.3" x="7" y="14" width="9" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</a>
				</div>

			</div>
		</>
	);
}
export default AsideNavbar;